import { sendAnalyticsEvent } from '@devsbb/analytics-client';
import { CategoriesWidgetEventProperties } from './types';

export const trackCategoriesClicksAction = (properties: CategoriesWidgetEventProperties) =>
    sendAnalyticsEvent<CategoriesWidgetEventProperties>(
        'Homepage Category Widget Clicked',
        properties,
    );
